import { Stack, Tooltip } from "@mui/material";
import { ResponsiveGenericTable } from "../../../components/GenericTable/ResponsiveGenericTable";
import { useSessionContext } from "../../../contexts/SessionContext";
import { useFormatter } from "../../../utils/useFormatter";
import dayjs from "dayjs";
import { DependentListActions } from "./DependentListActions";
import { Check, Warning } from "@mui/icons-material";
import { useEffect, useState } from "react";
import { GetConsents } from "../../../services/consent";
import { ListSectionAccordion } from "./ListSectionAccordion";

const translateSex: Record<string, string> = {
  male: "Masculino",
  female: "Feminino",
};

export function DependentList() {
  const { patientRelated, user } = useSessionContext();

  const [received, setReceived] = useState([]);

  const getColumns = (rows: any[]) => {
    const cols = [
      { column: "Nome", rowName: "name" },
      { column: "CPF", rowName: "identifier" },
    ];

    const hasBirthDate = rows?.some(
      (el: any) =>
        el &&
        el.birthDate &&
        el.birthDate !== "-" &&
        el.birthDate !== "" &&
        el.birthDate !== undefined
    );

    if (hasBirthDate) {
      cols.push({ column: "Data de nascimento", rowName: "birthDate" });
    }

    const hasGender = rows?.some(
      (el: any) =>
        el &&
        el.gender &&
        el.gender !== "unknown" &&
        el.gender !== "-" &&
        el.gender !== "" &&
        el.gender !== undefined
    );

    if (hasGender) {
      cols.push({ column: "Sexo de nascimento", rowName: "gender" });
    }

    cols.push({ column: "Verificado", rowName: "active" });
    cols.push({ column: "Status", rowName: "ends" });

    return cols;
  };

  const rows = patientRelated
    ?.map((el: any) => ({
      name: useFormatter.formatNameDisplay(el?.name?.[0]?.text),
      identifier: useFormatter.formatCPF(el?.id?.split("-")[1] || ""),
      birthDate: el?.birthDate ? dayjs(el?.birthDate).format("DD/MM/YYYY") : undefined,
      gender: translateSex[el?.gender || "unknown"],
      active: el?.isVerify ? (
        <Tooltip title="Verificação realizada">
          <Check color="primary" />
        </Tooltip>
      ) : (
        <>
          {el?.period?.start ? (
            <Tooltip title="Verificação pendente">
              <Warning sx={{ color: "warning500.main" }} />
            </Tooltip>
          ) : (
            <> - </>
          )}
        </>
      ),
      ends: el?.period?.end ? "Inativo" : "Ativo",
      start: el?.period?.start,
      end: el?.period?.end,
      relatedId: el?.relatedId,
      verify: el?.isVerify,
      fullResource: el,
    }))
    ?.sort((a: any, b: any) => a?.name?.localeCompare(b?.name))
    ?.sort((a: any, b: any) => b?.verify - a?.verify);

  useEffect(() => {
    async function fetchData() {
      try {
        const receivedResponse = await GetConsents({
          identifier: user.username,
          type: "received",
        });
        setReceived(
          receivedResponse?.data
            ?.filter(
              (el: any) =>
                el?.recurso?.id !== user.username && el?.recurso?.nome
            )
            ?.map((el: any) => ({
              id: el?.recurso?.id,
              purpose: el?.contexto?.motivoAcesso,
            }))
        );
      } catch (err) {
        console.log("Fetch consents", err);
      }
    }
    fetchData();
  }, [user.username]);

  return (
    <Stack width="100%" sx={{ mt: { xs: 2.5, md: 0 } }}>
      <ListSectionAccordion
        title="Lista de dependentes"
        subtitle="Gerencie cadastro, status e acesso ao prontuário"
      >
        <ResponsiveGenericTable
          tableColumns={getColumns(rows)}
          tableRows={rows}
          actions={(rowData: any) => (
            <DependentListActions row={rowData} received={received} />
          )}
        />
      </ListSectionAccordion>
    </Stack>
  );
}
